import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
    id: number;
    title: string;
    message: string;
    timestamp: string;
    status: 'read' | 'unread';
}

interface NotificationState {
    notifications: Notification[];
    unreadCount: number;
}

const initialState: NotificationState = {
    notifications: [
        { id: 1, title: 'Project Approved', message: 'Your project has been approved.', timestamp: '2025-03-04 10:00', status: 'unread' },
        { id: 2, title: 'Funds Released', message: 'Funds have been released for your project.', timestamp: '2025-03-04 09:30', status: 'unread' },
        { id: 3, title: 'Document Updated', message: 'A new document has been added to your project.', timestamp: '2025-03-03 14:15', status: 'read' },
        { id: 3, title: 'Project Approved', message: 'Your project has been approved.', timestamp: '2025-03-04 10:00', status: 'unread' },
        { id: 4, title: 'Funds Released', message: 'Funds have been released for your project.', timestamp: '2025-03-04 09:30', status: 'unread' },
        { id: 5, title: 'Document Updated', message: 'A new document has been added to your project.', timestamp: '2025-03-03 14:15', status: 'read' }
    ],
    unreadCount: 2,
};

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        markAsRead: (state, action: PayloadAction<number>) => {
            const notification = state.notifications.find(n => n.id === action.payload);
            if (notification && notification.status === 'unread') {
                notification.status = 'read';
                state.unreadCount -= 1;
            }
        }
    }
});

export const { markAsRead } = notificationSlice.actions;
export default notificationSlice.reducer;
